const t = {
  name: "Mauritius",
  dimensions: { width: 24, height: 24 },
  content: `
<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M13.0601 7.82929C14.2253 7.41746 15.0601 6.30622 15.0601 5C15.0601 3.34315 13.7169 2 12.0601 2C10.4032 2 9.06006 3.34315 9.06006 5C9.06006 6.30622 9.89487 7.41746 11.0601 7.82929V9H6.06006V11H11.0601V19.937C8.34892 19.5962 6.06101 17.9016 4.89573 15.5552L4.45094 14.6595L2.65967 15.5491L3.10446 16.4448C4.737 19.732 8.13623 22 12.0701 22C15.9946 22 19.3935 19.7315 21.0257 16.4448L21.4705 15.5491L19.6793 14.6595L19.2345 15.5552C18.0665 17.907 15.7711 19.6034 13.0601 19.9391V11H18.0601V9H13.0601V7.82929ZM11.0601 5C11.0601 4.44772 11.5078 4 12.0601 4C12.6123 4 13.0601 4.44772 13.0601 5C13.0601 5.55228 12.6123 6 12.0601 6C11.5078 6 11.0601 5.55228 11.0601 5Z" fill="currentColor"/>
</svg>
  `
};
export {
  t as Mauritius
};
